import { useKestrel } from 'features/kestrelViewer'
import { GenericEditButton } from 'features/kestrelViewer/kestrelViewerMarkup/utils/GenericEditButton'
import React, { FC } from 'react'
import { Vector2 } from 'three'
import { KVPrimitive } from 'types'

export const EditPrimitiveButton: FC<{
  primitive: KVPrimitive
}> = ({ primitive }) => {
  const { setPopupMenuStartPosition, setSelectedMarkup } = useKestrel()

  const handleEdit = () => {
    if (setPopupMenuStartPosition) {
      setPopupMenuStartPosition(new Vector2(80, 20))
    }
    setSelectedMarkup(primitive)
  }

  return (
    <GenericEditButton
      itemId={primitive.id}
      tooltipLabel='Edit primitive'
      onEdit={handleEdit}
    />
  )
}
